<template>
  <div>
    <div v-if="!mostrarDetalleFicha" class="card card-custom card-sticky mb-5">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            <span class="label label-xl label-dot label-danger mr-2"></span>
            Turno 2 - Mesa
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{
              auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="cargar()">
            <i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin' : '']"></i>
          </a>
        </div>
      </div>
    </div>

    <div v-if="mostrarDetalleFicha" class="card card-custom card-sticky mb-5">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
          <span class="label label-xl label-dot label-danger mr-2"></span>
          Turno 2 - Mesa
          <small v-if="auth.fechaInicioTurno">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
        </h3>
      </div>
      <div class="card-toolbar">
        <span class="label label-lg label-inline mr-3" :class="porcentajeAvance >= 100 ? 'label-light-success' : 'label-light-warning'"
              v-b-tooltip.hover.top title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
          {{ porcentajeAvance }}% completado
        </span>
        <span v-if="finalizado" class="label label-lg label-inline label-success mr-3">Finalizado</span>
        <button v-if="finalizado && puedeReanudarTurno" type="button" class="btn btn-sm btn-warning font-weight-bold mr-2"
                :disabled="ui.estaGuardando" @click.prevent="reabrir()">Reabrir turno</button>
        <a v-if="!finalizado" href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" :disabled="ui.estaGuardando || soloLectura"
           @click.prevent="guardar(false)">
          <i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i>
          Guardar cambios
        </a>
        <a href="#" class="btn btn-icon btn-sm btn-light-primary"
           @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
          <i :class="expandirContenido ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
        </a>
      </div>
    </div>

    <div class="card-body border-bottom px-3 px-md-9 py-4 py-md-6 bg-white">
      <h5 class="font-weight-bold text-dark mb-4">SECCIÓN 1 - IDENTIFICACIÓN</h5>

      <div class="form-group row">
        <div class="col-12 col-md-4">
          <label class="mb-1">Número de mesa</label>
          <input type="text" class="form-control" v-model="actual.t2NumeroMesaIngresado"
                 placeholder="Número de mesa..." :disabled="soloLectura" />
          <small v-if="actual.t2NumeroMesaIngresado && !numeroMesaConfirmado" class="text-danger">
            El número ingresado no coincide con el de la mesa asignada.
          </small>
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">Nombre y Apellido del Observador/a</label>
          <input type="text" class="form-control" v-model="actual.t2ObservadorNombre" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">DNI</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="actual.t2ObservadorDni"
                   placeholder="DNI o documento..." :disabled="soloLectura" />
            <consulta-voluntario v-if="puedeConsultarVoluntario"
                                 :documento="actual.t2ObservadorDni"
                                 :mesa-votacion-id="mesaVotacionId"
                                 :proceso-electoral-id="procesoElectoralId"
                                 :turno="2" />
          </div>
        </div>
      </div>

      <h6 class="font-weight-bold text-dark mb-3 mt-2">REGISTRO DE ASISTENCIA</h6>

      <div class="form-group row mb-0">
        <div class="col-12 col-md-4">
          <label class="mb-1">Hora de ingreso <span class="text-muted">(1 pm)</span></label>
          <input type="time" class="form-control" v-model="actual.t2HoraIngreso" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">Hora de salida <span class="text-muted">(8pm)</span></label>
          <input type="time" class="form-control" v-model="actual.t2HoraSalida" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4 d-flex align-items-end">
          <button type="button" class="btn btn-block font-weight-bold"
                  :class="[actual.t2HoraIngreso ? 'btn-success' : 'btn-primary']"
                  :disabled="soloLectura" @click.prevent="registrarAsistencia()">
            <i v-if="actual.t2HoraIngreso" class="fa fa-check mr-1"></i>
            REGISTRA TU ASISTENCIA
          </button>
        </div>
      </div>

      <div v-if="!cuestionarioHabilitado" class="alert alert-custom alert-light-info mt-4 mb-0">
        <div class="alert-text">
          Completa el nombre del observador, el DNI y el número de mesa, y registra tu hora de ingreso,
          para habilitar el cuestionario.
        </div>
      </div>

      <div v-else-if="!expandirContenido" class="text-center mt-4 pt-3 border-top">
        <a href="#" class="font-weight-bold" @click.prevent="$emit('update:expandirContenido', true)">Ver ficha</a>
      </div>
    </div>

    <div v-show="expandirContenido && mostrarDetalleFicha" class="card-body px-3 px-md-9 py-4 py-md-8">
        <form v-if="cuestionarioHabilitado" class="form" id="frm-mesa-erm-lima-2026-turno-2">
          <q-seccion titulo="SECCIÓN 2 - INICIO DE LA JORNADA">
            <q-si-no v-model="actual.t2PermitioIngresoLocal"
                     label="2.1 ¿Se te permitió el ingreso al local de votación?"
                     :solo-lectura="soloLectura" @cambio="cambiarPermisoIngreso" />

            <q-multiple :valores="actual" label="2.2 ¿Qué actores se encuentran en el local de votación?"
                        :opciones="opcionesActores" :aplica="fichaActiva" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-si-no v-model="actual.t2SenializacionAdecuada"
                     label="2.3 ¿La señalización y acondicionamiento del local de votación fue adecuada? (señalización de entrada, salida, croquis de ubicación de mesas)"
                     :aplica="fichaActiva" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PersonalOrientador"
                     label="2.4 ¿Hubo personal orientador para los electores por parte de ONPE?"
                     :aplica="fichaActiva" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="!fichaActiva" class="alert alert-custom alert-light-danger">
            <div class="alert-text">
              Registraste que no se te permitió el ingreso al local de votación. No corresponde completar el resto
              de la ficha; comunícate con tu coordinador.
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 3 - ACCESIBILIDAD" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2LocalRampas" label="3.1 ¿El local cuenta con rampas de accesibilidad?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t2LocalBanosAguaPotable"
                     label="3.2 ¿El local cuenta con baños habilitados con agua potable para su uso?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t2LocalMtv" label="3.3 ¿El local cuenta con el Módulo Temporal de Votación (MTV)?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t2LocalZonaSegura"
                     label="3.4 ¿El local cuenta con señalización de zona segura en caso de sismos?" :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 4 - VOTACIÓN EN LA MESA DE SUFRAGIO" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2InterrupcionSufragio"
                     label="4.1 ¿Hubo alguna interrupción durante el proceso de sufragio?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2InterrupcionSufragio')" />

            <q-multiple :valores="actual" label="Si la respuesta es Si, indique el motivo:"
                        :opciones="opcionesMotivoInterrupcion" :aplica="actual.t2InterrupcionSufragio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2InterrupOtroDetalle" label="Otro:" placeholder="Indique el motivo..."
                     :aplica="actual.t2InterrupOtro === true" :solo-lectura="soloLectura" />

            <q-si-no-no-aplica v-model="actual.t2AtencionPrioritaria"
                               label="4.2 ¿Se observó atención prioritaria en la mesa de sufragio? (a personas con discapacidad, madres gestantes, adultos mayores)"
                               :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2ActoIntimidacion"
                     label="4.3 ¿Se ha detectado algun acto de intimidación, coacción, agresión o violencia que impida el ejercicio del voto ciudadano en la mesa de votación?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2ActoIntimidacion')" />

            <q-texto v-model="actual.t2ActoIntimidacionDetalle" label="Si la respuesta fue Si, indique el motivo"
                     placeholder="Describa el hecho observado..." :aplica="actual.t2ActoIntimidacion === true"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PropagandaDentroMesa"
                     label="4.4 ¿Se observó propaganda política dentro de la mesa de sufragio?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PropagandaDentroMesa')" />

            <q-multiple :valores="actual" label="Si la respuesta fue Si, indique el motivo"
                        :opciones="opcionesTipoPropaganda" :aplica="actual.t2PropagandaDentroMesa === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2PropMesaOtroDetalle" label="Otros:" placeholder="Indique el tipo..."
                     :aplica="actual.t2PropMesaOtro === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PresenciaPersonerosVotacion"
                     label="4.5 ¿Hay presencia de personeros durante la votación?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PresenciaPersonerosVotacion')" />

            <q-organizaciones v-model="actual.t2PresenciaPersonerosVotacionOrganizacionParamIds"
                              label="Si la respuesta fue Si, indique de qué organizaciones políticas:"
                              :organizaciones="organizaciones" :aplica="actual.t2PresenciaPersonerosVotacion === true"
                              :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2HechoImpideLaborSufragio"
                     label="4.6 ¿Se presentó/produjo algún hecho que interrumpa o impida el ejercicio de tus funciones como observador/a electoral durante el sufragio?"
                     incidencia :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2HechoImpideLaborSufragio')" />

            <q-multiple :valores="actual"
                        label="Si la respuesta fue SI, indique el motivo y comunícate con tu coordinador:"
                        :opciones="opcionesMotivoLaborSufragio" :aplica="actual.t2HechoImpideLaborSufragio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-multiple :valores="actual" label="Desconocimiento de la labor del observador, ¿por parte de quién?"
                        :opciones="opcionesActorLaborSufragio"
                        :aplica="actual.t2LaborSufragioDesconocimientoLabor === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2LaborSufragioOtroDetalle" label="Otro:" placeholder="Indique el motivo..."
                     :aplica="actual.t2LaborSufragioOtro === true" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="fichaActiva" class="alert alert-custom alert-light-info">
            <div class="alert-text">
              <span class="font-weight-bold">PRIMER CORTE DE INFORMACIÓN - 3:30 PM.</span>
              Toda la información recogida en la ficha hasta las 3:30 pm deberás subirla a la plataforma
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 5 - CIERRE DEL SUFRAGIO E INICIO DEL ESCRUTINIO" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2ElectoresDentroLocal1700"
                     label="5.1 A las 17:00 hrs ¿Quedaban electores dentro del local de votación?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2ElectoresDentroLocal1700')" />

            <q-si-no v-model="actual.t2ElectoresDentroLocalPermitioVotar"
                     label="Si la respuesta fue SI, ¿se les permitió votar?"
                     :aplica="actual.t2ElectoresDentroLocal1700 === true" :solo-lectura="soloLectura" />

            <q-hora v-model="actual.t2HoraInicioEscrutinio"
                    label="5.2 Hora de inicio del escrutinio de la mesa seleccionada."
                    :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PresenciaObservadoresEscrutinio"
                     label="5.3 ¿Se permitió la presencia de observadores durante el escrutinio de la mesa selecionada?"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PresenciaPersonerosAcreditadosEscrutinio"
                     label="5.4 ¿Se permitió la presencia de personeros acreditados durante el escrutinio de la mesa seleccionada?"
                     :solo-lectura="soloLectura" />

            <q-multiple :valores="actual"
                        label="5.5 ¿Hubo otros actores presentes durante el escrutinio de la mesa selecionada?"
                        ayuda="Marque 1 o más actores electorales"
                        :opciones="opcionesActoresEscrutinio" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2EscrutinioActorOtroDetalle" label="Otros:" placeholder="Indique el actor..."
                     :aplica="actual.t2EscrutinioActorOtro === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2ConteoCedulasPresenciaAsistentes"
                     label="5.6 ¿Los miembros de mesa sacaron las cédulas del ánfora y las contaron en presencia de los asistentes de la mesa selecionada?"
                     :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 6 - ESCRUTINIO Y TRANSPARENCIA EN LOS PROCEDIMIENTOS" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2CedulasCoincidenVotantes"
                     label="6.1 ¿El número total de cédulas del ánfora coincidió con el número de ciudadanos que votaron?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2CedulasCoincidenVotantes')" />

            <q-multiple :valores="actual" label="Si la respuesta fue NO, indique qué hicieron los miembros de mesa:"
                        :opciones="opcionesCedulasNoCoinciden" :aplica="actual.t2CedulasCoincidenVotantes === false"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2CedulasNoCoincidenOtraAccionDetalle" label="Otro acción"
                     placeholder="Indique la acción..." :aplica="actual.t2CedulasNoCoincidenOtraAccion === true"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2CedulasMostradasPublicamente"
                     label="6.2 ¿Los miembros de mesa mostraron públicamente cada cédula al momento de leer y registrar el voto?"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PersonerosAcuerdoActas"
                     label="6.3 ¿Los personeros estuvieron de acuerdo con la información registrada en las actas?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PersonerosAcuerdoActas')" />

            <q-texto v-model="actual.t2PersonerosAcuerdoActasNoDetalle" label="Si la respuesta fue No, detalla"
                     placeholder="Detalle..." :aplica="actual.t2PersonerosAcuerdoActas === false"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2ImpugnacionVotoMesa"
                     label="6.4 ¿Hubo impugnación de voto en la mesa?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2ImpugnacionVotoMesa')" />

            <q-texto v-model="actual.t2ImpugnacionVotoMesaNoDetalle" label="Si la respuesta fue No, detalla"
                     placeholder="Detalle..." :aplica="actual.t2ImpugnacionVotoMesa === false"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PedidoNulidadMesa"
                     label="6.5 ¿Hubo algún pedido de nulidad de la mesa por parte de los personeros?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PedidoNulidadMesa')" />

            <q-texto v-model="actual.t2PedidoNulidadMesaNoDetalle" label="Si la respuesta fue No, detalla"
                     placeholder="Detalle..." :aplica="actual.t2PedidoNulidadMesa === false"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2IncidenteEscrutinio"
                     label="6.6 ¿Se registró algún incidente o altercado entre los presentes durante el escrutinio?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2IncidenteEscrutinio')" />

            <q-multiple :valores="actual" label="Si la respuesta fue Sí, indique qué tipo de incidente hubo:"
                        :opciones="opcionesIncidenteEscrutinio" :aplica="actual.t2IncidenteEscrutinio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2IncidenteEscrutinioOtroDetalle" label="Otro"
                     placeholder="Indique el tipo..." :aplica="actual.t2IncidenteEscrutinioOtro === true"
                     :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 7 - LLENADO DE ACTAS ELECTORALES" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2MiembrosMesaAcuerdoActas"
                     label="7.1 ¿Estuvieron de acuerdo todos los miembros de mesa con la información registrada en las actas?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2MiembrosMesaAcuerdoActas')" />

            <q-texto v-model="actual.t2MiembrosMesaAcuerdoActasNoDetalle" label="Si la respuesta fue No, detalla"
                     placeholder="Detalle..." :aplica="actual.t2MiembrosMesaAcuerdoActas === false"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2DificultadesLlenadoActas"
                     label="7.2 ¿Los miembros de mesa tuvieron dificultades para el llenados de las actas de escrutinio?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2DificultadesLlenadoActas')" />

            <q-si-no v-model="actual.t2DificultadesLlenadoActasAsistenciaOnpe"
                     label="Si la respuesta fue SI, ¿recibieron asistencia del personal de la ONPE?"
                     :aplica="actual.t2DificultadesLlenadoActas === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2HechoImpideLaborEscrutinio"
                     label="7.3 ¿Se presentó/produjo algún hecho que interrumpa o impida el ejercicio de tus funciones como observador/a electoral durante el escrutinio?"
                     incidencia :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2HechoImpideLaborEscrutinio')" />

            <q-multiple :valores="actual"
                        label="Si la respuesta fue SI, explique el motivo y comunícate con tu coordinador:"
                        :opciones="opcionesMotivoLaborEscrutinio" :aplica="actual.t2HechoImpideLaborEscrutinio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-multiple :valores="actual" label="Desconocimiento de la labor del observador, ¿por parte de quién?"
                        :opciones="opcionesActorLaborEscrutinio"
                        :aplica="actual.t2LaborEscrutinioDesconocimientoLabor === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2LaborEscrutinioOtroDetalle" label="Otro:" placeholder="Indique el motivo..."
                     :aplica="actual.t2LaborEscrutinioOtro === true" :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 8 - RESULTADOS ELECTORALES" :aplica="fichaActiva"
                     descripcion="Instrucciones: Complete la siguiente información según aparece en el Acta de Escrutinio. Para información sobre votos emitidos, recoja la información sobre la elección provincial en la primera columna.">
            <q-numero v-model="actual.t2TotalElectoresHabiles"
                      label="8.1 TOTAL DE ELECTORES HABILES"
                      placeholder="Cantidad..." :solo-lectura="soloLectura" />

            <q-fila label="8.2 Votos por organización política"
                    ayuda="Completa los votos de cada organización según figuran en el acta. Debes ingresar la cantidad de votos (0 o más) en todas las organizaciones."
                    :completa="votosPartidosCompletos">
                    
                    <div class="alert alert-custom alert-light-info py-2 mb-3 px-5 align-items-center">
      <i class="fa fa-info-circle mr-3 text-info"></i>
      <div style="border-left: 1px solid #c0a1ff; padding-left: 12px;">
        Para cada organización registra los votos de la <b>elección provincial (primera columna)</b>.
        <br>
        Si no hay votos debes registrar 0.
      </div>
    </div>

              <div class="table-responsive ficha-acta-partidos">
                <table class="table table-sm table-bordered mb-0 table-hover">
                  <thead>
                    <tr>
                      <th>Organización política</th>
                      <th class="ficha-acta-partidos__col-votos">Votos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="partido in partidosActa" :key="partido.campo"
                        :class="{ 'ficha-acta-partidos__fila--pendiente': !votoPartidoCompleto(actual[partido.campo]) }">
                      <td>
                        <div class="ficha-acta-partidos__org">
                          <img :src="urlLogoPartido(partido.logo)"
                               :alt="partido.etiqueta"
                               class="ficha-acta-partidos__logo"
                               @error="ocultarLogoRoto" />
                          <span>{{ partido.etiqueta }}</span>
                        </div>
                      </td>
                      <td class="ficha-acta-partidos__col-votos">
                        <input type="number" min="0" step="1" class="form-control form-control-sm"
                               :value="actual[partido.campo]"
                               :disabled="soloLectura"
                               placeholder="-"
                               @input="asignarVotoPartido(partido.campo, $event.target.value)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <small v-if="!votosPartidosCompletos" class="text-danger d-block mt-2">
                  Faltan {{ partidosActaPendientes }} organizaciones. Ingresa 0 si no obtuvo votos.
                </small>
              </div>
            </q-fila>

            <q-numero v-model="actual.t2VotosEnBlanco"
                      label="8.3 VOTOS EN BLANCO"
                      placeholder="Cantidad..." :solo-lectura="soloLectura" />
            <q-numero v-model="actual.t2VotosNulos"
                      label="8.4 VOTOS NULOS"
                      placeholder="Cantidad..." :solo-lectura="soloLectura" />
            <q-numero v-model="actual.t2VotosImpugnados"
                      label="8.5 VOTOS IMPUGNADOS"
                      placeholder="Cantidad..." :solo-lectura="soloLectura" />
            <q-numero v-model="actual.t2TotalVotosEmitidos"
                      label="8.6 TOTAL DE VOTOS EMITIDOS"
                      placeholder="Cantidad..." :solo-lectura="soloLectura" />
            <q-numero v-model="actual.t2TotalCiudadanosVotaron"
                      label="8.7 TOTAL DE CIUDADANOS QUE VOTARON"
                      placeholder="Cantidad..." :solo-lectura="soloLectura" />

            <ficha-acta-escrutinio v-model="actual.rutaActaEscrutinio"
                                   controlador="Ficha2026ErmLima"
                                   :local-votacion-mesa-proceso-electoral-id="asignacionId || localVotacionMesaProcesoElectoralId"
                                   :mesa-votacion-id="mesaVotacionId"
                                   :proceso-electoral-id="procesoElectoralId"
                                   :solo-lectura="soloLectura"
                                   @guardado="onActaGuardada" />
          </q-seccion>

          <div v-if="fichaActiva" class="alert alert-custom alert-light-info">
            <div class="alert-text">
              <span class="font-weight-bold">SEGUNDO CORTE DE INFORMACIÓN 6:00 PM</span>
              Toda la información recogida en la ficha hasta las 6:00 pm deberás subirla a la plataforma
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 9 - REGISTRO DE INCIDENCIAS" :aplica="fichaActiva"
                     descripcion="Revisa la cartilla para identificar el tipo de incidencia y reporta el hechoen la plataforma. Describe los hechos de manera breve, identifica actores involucrados e indica la ubicación (interior del local, exterior, mesa de sufragio, ingreso, etc.). No olvides adjuntar la evidencia y reportar la incidencia a tu coordinador.">
            <ficha-incidencias :local-votacion-mesa-proceso-electoral-id="asignacionId || localVotacionMesaProcesoElectoralId"
                               :mesa-votacion-id="mesaVotacionId" :proceso-electoral-id="procesoElectoralId"
                               :turno="2" :solo-lectura="soloLectura" />
          </q-seccion>

          <div class="separator separator-dashed my-6"></div>

          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div class="text-muted">
              <span v-if="camposPendientes.length"
                    v-b-tooltip.hover.top
                    title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
                <b>{{ camposPendientes.length }}</b> respuestas pendientes
              </span>
              <span v-else class="text-success font-weight-bold">Todas las respuestas obligatorias están completas.</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <span class="label label-lg label-inline mr-3" :class="porcentajeAvance >= 100 ? 'label-light-success' : 'label-light-warning'"
                    v-b-tooltip.hover.top
                    title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
                {{ porcentajeAvance }}% completado
              </span>
              <template v-if="!finalizado">
                <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" :disabled="ui.estaGuardando || soloLectura"
                   @click.prevent="guardar(false)">
                  <i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i>
                  Guardar cambios
                </a>
                <button type="button" class="btn btn-sm btn-primary" :disabled="ui.estaGuardando || soloLectura || camposPendientes.length > 0"
                        @click.prevent="finalizar()">Finalizar turno 2</button>
              </template>
              <button v-else-if="puedeReanudarTurno" type="button" class="btn btn-sm btn-warning"
                      :disabled="ui.estaGuardando" @click.prevent="reabrir()">Reabrir turno</button>
            </div>
          </div>
        </form>
    </div>
    </div>
  </div>
</template>

<script>
/**
 * Ficha de observación electoral integral ERM 2026 - Lima Metropolitana, Turno 2.
 * Literales y numeración del PDF "Ficha LIMA Turno 2".
 */
import QSeccion from "../ui/QSeccion";
import QSiNo from "../ui/QSiNo";
import QSiNoNoAplica from "../ui/QSiNoNoAplica";
import QMultiple from "../ui/QMultiple";
import QTexto from "../ui/QTexto";
import QHora from "../ui/QHora";
import QNumero from "../ui/QNumero";
import QFila from "../ui/QFila";
import QOrganizaciones from "../ui/QOrganizaciones";
import FichaIncidencias from "../FichaIncidencias";
import FichaActaEscrutinio from "../FichaActaEscrutinio";
import ConsultaVoluntario from "../ui/ConsultaVoluntario";

const SEPARADOR_ORGANIZACIONES = "|";

const URL_LOGO_OP = "https://stovotoinformadodev.blob.core.windows.net/contenedor-2/";

// Orden según cédula de votación (no alfabético; personeros usan el catálogo Parametro ordenado A-Z).
const PARTIDOS_ACTA = [
  { campo: "t2VotosAlianzaParaElProgreso", etiqueta: "ALIANZA PARA EL PROGRESO", logo: "1257.png" },
  { campo: "t2VotosPartidoPoliticoNacionalPeruLibre", etiqueta: "PARTIDO POLITICO NACIONAL PERU LIBRE", logo: "2218.png" },
  { campo: "t2VotosJuntosPorElPeru", etiqueta: "JUNTOS POR EL PERU", logo: "1264.png" },
  { campo: "t2VotosPartidoFrenteDeLaEsperanza2021", etiqueta: "PARTIDO FRENTE DE LA ESPERANZA 2021", logo: "2857.png" },
  { campo: "t2VotosAccionPopular", etiqueta: "ACCION POPULAR", logo: "4.png" },
  { campo: "t2VotosPartidoCivicoObras", etiqueta: "PARTIDO CIVICO OBRAS", logo: "2941.png" },
  { campo: "t2VotosCoalicionTransformadoraTierraVerde", etiqueta: "COALICION TRANSFORMADORA TIERRA VERDE", logo: "2982.png" },
  { campo: "t2VotosRenovacionPopularPeru", etiqueta: "RENOVACION POPULAR PERU", logo: "3040.png" },
  { campo: "t2VotosPartidoDemocrataVerde", etiqueta: "PARTIDO DEMOCRATA VERDE", logo: "2895.png" },
  { campo: "t2VotosPartidoPopularCristianoPpc", etiqueta: "PARTIDO POPULAR CRISTIANO - PPC", logo: "2943.png" },
  { campo: "t2VotosVisionPeru", etiqueta: "VISION PERU", logo: "2988.png" },
  { campo: "t2VotosFrentePopularAgricolaFiaDelPeru", etiqueta: "FRENTE POPULAR AGRICOLA FIA DEL PERU", logo: "2901.png" },
  { campo: "t2VotosFuerzaPopular", etiqueta: "FUERZA POPULAR", logo: "1366.png" },
  { campo: "t2VotosAvanzaPaisPartidoDeIntegracionSocial", etiqueta: "AVANZA PAIS - PARTIDO DE INTEGRACION SOCIAL", logo: "2173.png" },
  { campo: "t2VotosPartidoPatrioticoDelPeru", etiqueta: "PARTIDO PATRIOTICO DEL PERU", logo: "2869.png" },
  { campo: "t2VotosFuerzaCiudadana", etiqueta: "FUERZA CIUDADANA", logo: "3009.png" },
  { campo: "t2VotosBatallaPeru", etiqueta: "BATALLA PERU", logo: "2984.png" },
  { campo: "t2VotosAhoraNacionAn", etiqueta: "AHORA NACION - AN", logo: "2980.png" },
  { campo: "t2VotosProgresemos", etiqueta: "PROGRESEMOS", logo: "2967.png" },
  { campo: "t2VotosPartidoDelBuenGobierno", etiqueta: "PARTIDO DEL BUEN GOBIERNO", logo: "2961.png" },
  { campo: "t2VotosPartidoPoliticoPuebloConsciente", etiqueta: "PARTIDO POLITICO PUEBLO CONSCIENTE", logo: "3001.png" },
  { campo: "t2VotosPartidoDemocraticoSomosPeru", etiqueta: "PARTIDO DEMOCRATICO SOMOS PERU", logo: "14.png" },
  { campo: "t2VotosPartidoApristaPeruano", etiqueta: "PARTIDO APRISTA PERUANO", logo: "2930.png" },
  { campo: "t2VotosPodemosPeru", etiqueta: "PODEMOS PERU", logo: "2731.png" },
  { campo: "t2VotosAlianzaElectoralVenceremos", etiqueta: "ALIANZA ELECTORAL VENCEREMOS", logo: "3028.png" },
  { campo: "t2VotosPartidoMorado", etiqueta: "PARTIDO MORADO", logo: "2840.png" },
];

const TOTALES_ACTA = [
  "t2TotalElectoresHabiles",
  "t2VotosEnBlanco",
  "t2VotosNulos",
  "t2VotosImpugnados",
  "t2TotalVotosEmitidos",
  "t2TotalCiudadanosVotaron",
];

const DEPENDIENTES = {
  t2InterrupcionSufragio: [
    "t2InterrupAusenciaMiembrosMesa",
    "t2InterrupTrasladoMtv",
    "t2InterrupAltercadoActores",
    "t2InterrupOtro",
  ],
  t2InterrupOtro: ["t2InterrupOtroDetalle"],
  t2ActoIntimidacion: ["t2ActoIntimidacionDetalle"],
  t2PropagandaDentroMesa: [
    "t2PropMesaVestimenta",
    "t2PropMesaMaterialGrafico",
    "t2PropMesaArengas",
    "t2PropMesaOtro",
  ],
  t2PropMesaOtro: ["t2PropMesaOtroDetalle"],
  t2PresenciaPersonerosVotacion: ["t2PresenciaPersonerosVotacionOrganizacionParamIds"],
  t2HechoImpideLaborSufragio: [
    "t2LaborSufragioDesconocimientoLabor",
    "t2LaborSufragioRestriccionMovilizarse",
    "t2LaborSufragioRestriccionObservarMesa",
    "t2LaborSufragioFaltaRespetoAgresion",
    "t2LaborSufragioSeparacionInconducta",
    "t2LaborSufragioOtro",
  ],
  t2LaborSufragioDesconocimientoLabor: [
    "t2LaborSufragioActorJne",
    "t2LaborSufragioActorOnpe",
    "t2LaborSufragioActorFfaaPnp",
  ],
  t2LaborSufragioOtro: ["t2LaborSufragioOtroDetalle"],
  t2ElectoresDentroLocal1700: ["t2ElectoresDentroLocalPermitioVotar"],
  t2EscrutinioActorOtro: ["t2EscrutinioActorOtroDetalle"],
  t2CedulasCoincidenVotantes: [
    "t2CedulasNoCoincidenMasCedulasAccionAzar",
    "t2CedulasNoCoincidenMenosCedulasAnotaObservacion",
    "t2CedulasNoCoincidenDesconoceProcedimientoSolicitaApoyo",
    "t2CedulasNoCoincidenOtraAccion",
  ],
  t2CedulasNoCoincidenOtraAccion: ["t2CedulasNoCoincidenOtraAccionDetalle"],
  t2PersonerosAcuerdoActas: ["t2PersonerosAcuerdoActasNoDetalle"],
  t2ImpugnacionVotoMesa: ["t2ImpugnacionVotoMesaNoDetalle"],
  t2PedidoNulidadMesa: ["t2PedidoNulidadMesaNoDetalle"],
  t2IncidenteEscrutinio: [
    "t2IncidenteEscrutinioPersonerosNoFacultados",
    "t2IncidenteEscrutinioAgresionActores",
    "t2IncidenteEscrutinioEscrutinioNoPublico",
    "t2IncidenteEscrutinioOtro",
  ],
  t2IncidenteEscrutinioOtro: ["t2IncidenteEscrutinioOtroDetalle"],
  t2MiembrosMesaAcuerdoActas: ["t2MiembrosMesaAcuerdoActasNoDetalle"],
  t2DificultadesLlenadoActas: ["t2DificultadesLlenadoActasAsistenciaOnpe"],
  t2HechoImpideLaborEscrutinio: [
    "t2LaborEscrutinioDesconocimientoLabor",
    "t2LaborEscrutinioRestriccionMovilizarse",
    "t2LaborEscrutinioRestriccionObservarMesa",
    "t2LaborEscrutinioFaltaRespetoAgresion",
    "t2LaborEscrutinioSeparacionInconducta",
    "t2LaborEscrutinioOtro",
  ],
  t2LaborEscrutinioDesconocimientoLabor: [
    "t2LaborEscrutinioActorJne",
    "t2LaborEscrutinioActorOnpe",
    "t2LaborEscrutinioActorFfaaPnp",
  ],
  t2LaborEscrutinioOtro: ["t2LaborEscrutinioOtroDetalle"],
};

const CAMPOS_POSTERIORES_A_INGRESO = [
  "t2ActorOnpe",
  "t2ActorJne",
  "t2ActorFfaaPnp",
  "t2ActorDefensoriaPueblo",
  "t2ActorMinisterioPublico",
  "t2ActorOtrosObservadoresNacionales",
  "t2ActorObservadoresInternacionales",
  "t2SenializacionAdecuada",
  "t2PersonalOrientador",
  "t2LocalRampas",
  "t2LocalBanosAguaPotable",
  "t2LocalMtv",
  "t2LocalZonaSegura",
  "t2InterrupcionSufragio",
  "t2AtencionPrioritaria",
  "t2ActoIntimidacion",
  "t2PropagandaDentroMesa",
  "t2PresenciaPersonerosVotacion",
  "t2HechoImpideLaborSufragio",
  "t2ElectoresDentroLocal1700",
  "t2HoraInicioEscrutinio",
  "t2PresenciaObservadoresEscrutinio",
  "t2PresenciaPersonerosAcreditadosEscrutinio",
  "t2EscrutinioActorOnpe",
  "t2EscrutinioActorJne",
  "t2EscrutinioActorDefensoriaPueblo",
  "t2EscrutinioActorMinisterioPublico",
  "t2EscrutinioActorOtro",
  "t2ConteoCedulasPresenciaAsistentes",
  "t2CedulasCoincidenVotantes",
  "t2CedulasMostradasPublicamente",
  "t2PersonerosAcuerdoActas",
  "t2ImpugnacionVotoMesa",
  "t2PedidoNulidadMesa",
  "t2IncidenteEscrutinio",
  "t2MiembrosMesaAcuerdoActas",
  "t2DificultadesLlenadoActas",
  "t2HechoImpideLaborEscrutinio",
].concat(TOTALES_ACTA, PARTIDOS_ACTA.map(function (p) { return p.campo; }));

export default {
  name: "Ficha2026ErmLimaTurno2",
  components: {
    QSeccion,
    QSiNo,
    QSiNoNoAplica,
    QMultiple,
    QTexto,
    QHora,
    QNumero,
    QFila,
    QOrganizaciones,
    FichaIncidencias,
    FichaActaEscrutinio,
    ConsultaVoluntario,
  },
  props: {
    localVotacionMesaProcesoElectoralId: { type: [Number, String], default: null },
    mesaVotacionId: { type: [Number, String], required: true },
    procesoElectoralId: { type: [Number, String], required: true },
    cabecera: { type: Object, default: () => ({}) },
    organizaciones: { type: Array, default: () => [] },
    expandirContenido: { type: Boolean, default: true },
    intervaloAutoGuardado: { type: Number, default: 5000 },
  },
  data() {
    return {
      ui: { estaGuardando: false, estaCargandoDatos: false, tieneCargaInicial: false },
      auth: {},
      porcentajeAvance: 0,
      finalizado: false,
      camposPendientes: [],
      numeroMesaEsperado: "",
      asignacionId: null,
      temporizador: null,
      actual: {
        t2ObservadorNombre: null,
        t2ObservadorDni: null,
        t2NumeroMesaIngresado: null,
        t2HoraIngreso: null,
        t2HoraSalida: null,
        t2PermitioIngresoLocal: null,
        t2ActorOnpe: null,
        t2ActorJne: null,
        t2ActorFfaaPnp: null,
        t2ActorDefensoriaPueblo: null,
        t2ActorMinisterioPublico: null,
        t2ActorOtrosObservadoresNacionales: null,
        t2ActorObservadoresInternacionales: null,
        t2SenializacionAdecuada: null,
        t2PersonalOrientador: null,
        t2LocalRampas: null,
        t2LocalBanosAguaPotable: null,
        t2LocalMtv: null,
        t2LocalZonaSegura: null,
        t2InterrupcionSufragio: null,
        t2InterrupAusenciaMiembrosMesa: null,
        t2InterrupTrasladoMtv: null,
        t2InterrupAltercadoActores: null,
        t2InterrupOtro: null,
        t2InterrupOtroDetalle: null,
        t2AtencionPrioritaria: null,
        t2ActoIntimidacion: null,
        t2ActoIntimidacionDetalle: null,
        t2PropagandaDentroMesa: null,
        t2PropMesaVestimenta: null,
        t2PropMesaMaterialGrafico: null,
        t2PropMesaArengas: null,
        t2PropMesaOtro: null,
        t2PropMesaOtroDetalle: null,
        t2PresenciaPersonerosVotacion: null,
        t2PresenciaPersonerosVotacionOrganizacionParamIds: null,
        t2HechoImpideLaborSufragio: null,
        t2LaborSufragioDesconocimientoLabor: null,
        t2LaborSufragioRestriccionMovilizarse: null,
        t2LaborSufragioRestriccionObservarMesa: null,
        t2LaborSufragioFaltaRespetoAgresion: null,
        t2LaborSufragioSeparacionInconducta: null,
        t2LaborSufragioOtro: null,
        t2LaborSufragioOtroDetalle: null,
        t2LaborSufragioActorJne: null,
        t2LaborSufragioActorOnpe: null,
        t2LaborSufragioActorFfaaPnp: null,
        t2ElectoresDentroLocal1700: null,
        t2ElectoresDentroLocalPermitioVotar: null,
        t2HoraInicioEscrutinio: null,
        t2PresenciaObservadoresEscrutinio: null,
        t2PresenciaPersonerosAcreditadosEscrutinio: null,
        t2EscrutinioActorOnpe: null,
        t2EscrutinioActorJne: null,
        t2EscrutinioActorDefensoriaPueblo: null,
        t2EscrutinioActorMinisterioPublico: null,
        t2EscrutinioActorOtro: null,
        t2EscrutinioActorOtroDetalle: null,
        t2ConteoCedulasPresenciaAsistentes: null,
        t2CedulasCoincidenVotantes: null,
        t2CedulasNoCoincidenMasCedulasAccionAzar: null,
        t2CedulasNoCoincidenMenosCedulasAnotaObservacion: null,
        t2CedulasNoCoincidenDesconoceProcedimientoSolicitaApoyo: null,
        t2CedulasNoCoincidenOtraAccion: null,
        t2CedulasNoCoincidenOtraAccionDetalle: null,
        t2CedulasMostradasPublicamente: null,
        t2PersonerosAcuerdoActas: null,
        t2PersonerosAcuerdoActasNoDetalle: null,
        t2ImpugnacionVotoMesa: null,
        t2ImpugnacionVotoMesaNoDetalle: null,
        t2PedidoNulidadMesa: null,
        t2PedidoNulidadMesaNoDetalle: null,
        t2IncidenteEscrutinio: null,
        t2IncidenteEscrutinioPersonerosNoFacultados: null,
        t2IncidenteEscrutinioAgresionActores: null,
        t2IncidenteEscrutinioEscrutinioNoPublico: null,
        t2IncidenteEscrutinioOtro: null,
        t2IncidenteEscrutinioOtroDetalle: null,
        t2MiembrosMesaAcuerdoActas: null,
        t2MiembrosMesaAcuerdoActasNoDetalle: null,
        t2DificultadesLlenadoActas: null,
        t2DificultadesLlenadoActasAsistenciaOnpe: null,
        t2HechoImpideLaborEscrutinio: null,
        t2LaborEscrutinioDesconocimientoLabor: null,
        t2LaborEscrutinioRestriccionMovilizarse: null,
        t2LaborEscrutinioRestriccionObservarMesa: null,
        t2LaborEscrutinioFaltaRespetoAgresion: null,
        t2LaborEscrutinioSeparacionInconducta: null,
        t2LaborEscrutinioOtro: null,
        t2LaborEscrutinioOtroDetalle: null,
        t2LaborEscrutinioActorJne: null,
        t2LaborEscrutinioActorOnpe: null,
        t2LaborEscrutinioActorFfaaPnp: null,
        t2TotalElectoresHabiles: null,
        t2VotosAccionPopular: null,
        t2VotosAhoraNacionAn: null,
        t2VotosAlianzaElectoralVenceremos: null,
        t2VotosAlianzaParaElProgreso: null,
        t2VotosAvanzaPaisPartidoDeIntegracionSocial: null,
        t2VotosBatallaPeru: null,
        t2VotosCoalicionTransformadoraTierraVerde: null,
        t2VotosFrentePopularAgricolaFiaDelPeru: null,
        t2VotosFuerzaCiudadana: null,
        t2VotosFuerzaPopular: null,
        t2VotosJuntosPorElPeru: null,
        t2VotosPartidoApristaPeruano: null,
        t2VotosPartidoCivicoObras: null,
        t2VotosPartidoDelBuenGobierno: null,
        t2VotosPartidoDemocrataVerde: null,
        t2VotosPartidoDemocraticoSomosPeru: null,
        t2VotosPartidoFrenteDeLaEsperanza2021: null,
        t2VotosPartidoMorado: null,
        t2VotosPartidoPatrioticoDelPeru: null,
        t2VotosPartidoPoliticoNacionalPeruLibre: null,
        t2VotosPartidoPoliticoPuebloConsciente: null,
        t2VotosPartidoPopularCristianoPpc: null,
        t2VotosPodemosPeru: null,
        t2VotosProgresemos: null,
        t2VotosRenovacionPopularPeru: null,
        t2VotosVisionPeru: null,
        t2VotosEnBlanco: null,
        t2VotosNulos: null,
        t2VotosImpugnados: null,
        t2TotalVotosEmitidos: null,
        t2TotalCiudadanosVotaron: null,
        rutaActaEscrutinio: null,
      },
      guardado: {},
    };
  },
  computed: {
    mostrarDetalleFicha() {
      return this.ui.tieneCargaInicial && (this.auth.autorizadoEdicionTurno || this.finalizado);
    },
    soloLectura() {
      return this.finalizado || !this.auth.autorizadoEdicionTurno;
    },
    puedeReanudarTurno() {
      return this.auth.puedeReanudarTurno === true;
    },
    puedeConsultarVoluntario() {
      return this.auth.puedeConsultarVoluntario === true || this.$session.get("CodigoRol") === "ADM";
    },
    numeroMesaConfirmado() {
      const ingresado = String(this.actual.t2NumeroMesaIngresado || "").trim();
      const esperado = String(this.numeroMesaEsperado || "").trim();
      return esperado.length > 0 && ingresado === esperado;
    },
    cuestionarioHabilitado() {
      return (
        String(this.actual.t2ObservadorNombre || "").trim().length > 0 &&
        String(this.actual.t2ObservadorDni || "").trim().length > 0 &&
        this.numeroMesaConfirmado &&
        String(this.actual.t2HoraIngreso || "").trim().length > 0
      );
    },
    fichaActiva() {
      return this.actual.t2PermitioIngresoLocal !== false;
    },
    opcionesActores() {
      return [
        { campo: "t2ActorOnpe", etiqueta: "Personal de ONPE" },
        { campo: "t2ActorJne", etiqueta: "Personal del JNE" },
        { campo: "t2ActorFfaaPnp", etiqueta: "Fuerzas Armadas o PNP" },
        { campo: "t2ActorDefensoriaPueblo", etiqueta: "Defensoría del Pueblo" },
        { campo: "t2ActorMinisterioPublico", etiqueta: "Ministerio Público" },
        { campo: "t2ActorOtrosObservadoresNacionales", etiqueta: "Otros observadores nacionales" },
        { campo: "t2ActorObservadoresInternacionales", etiqueta: "Observadores internacionales" },
      ];
    },
    opcionesMotivoInterrupcion() {
      return [
        { campo: "t2InterrupAusenciaMiembrosMesa", etiqueta: "Ausencia de miembros de mesa" },
        { campo: "t2InterrupTrasladoMtv", etiqueta: "Traslado de los miembros de mesa al Módulo Temporal de Votación" },
        { campo: "t2InterrupAltercadoActores", etiqueta: "Altercado entre actores electorales (personeros, JNE, ONPE, etc)" },
        { campo: "t2InterrupOtro", etiqueta: "Otro:" },
      ];
    },
    opcionesTipoPropaganda() {
      return [
        { campo: "t2PropMesaVestimenta", etiqueta: "Vestimenta o Indumentaria" },
        { campo: "t2PropMesaMaterialGrafico", etiqueta: "Material gráfico" },
        { campo: "t2PropMesaArengas", etiqueta: "Arengas" },
        { campo: "t2PropMesaOtro", etiqueta: "Otros" },
      ];
    },
    opcionesMotivoLaborSufragio() {
      return [
        { campo: "t2LaborSufragioDesconocimientoLabor", etiqueta: "Desconocimiento de la labor del observador" },
        { campo: "t2LaborSufragioRestriccionMovilizarse", etiqueta: "Restricción para movilizarse dentro del local de votación" },
        { campo: "t2LaborSufragioRestriccionObservarMesa", etiqueta: "Restricción para observar la mesa de votación" },
        { campo: "t2LaborSufragioFaltaRespetoAgresion", etiqueta: "Falta de respeto, agresión contra el observador" },
        { campo: "t2LaborSufragioSeparacionInconducta", etiqueta: "Separación del observador por inconducta o faltas a la normativa electoral" },
        { campo: "t2LaborSufragioOtro", etiqueta: "Otro" },
      ];
    },
    opcionesActorLaborSufragio() {
      return [
        { campo: "t2LaborSufragioActorJne", etiqueta: "JNE" },
        { campo: "t2LaborSufragioActorOnpe", etiqueta: "ONPE" },
        { campo: "t2LaborSufragioActorFfaaPnp", etiqueta: "FFAA/PNP" },
      ];
    },
    opcionesActoresEscrutinio() {
      return [
        { campo: "t2EscrutinioActorOnpe", etiqueta: "Personal de la ONPE" },
        { campo: "t2EscrutinioActorJne", etiqueta: "Personal del JNE" },
        { campo: "t2EscrutinioActorDefensoriaPueblo", etiqueta: "Defensoría del Pueblo" },
        { campo: "t2EscrutinioActorMinisterioPublico", etiqueta: "Ministerio Público" },
        { campo: "t2EscrutinioActorOtro", etiqueta: "Otros:" },
      ];
    },
    opcionesCedulasNoCoinciden() {
      return [
        {
          campo: "t2CedulasNoCoincidenMasCedulasAccionAzar",
          etiqueta: "Si hay más cédulas que votantes, los miembros de mesa eligieron una cédula al azar, la desecharon y se anotó el hecho en la sección de observaciones del acta de escrutinio.",
        },
        {
          campo: "t2CedulasNoCoincidenMenosCedulasAnotaObservacion",
          etiqueta: "Si hay menos cédulas que votantes, los miembros de mesa anotan el hecho en la sección de observaciones del acta de sufragio.",
        },
        {
          campo: "t2CedulasNoCoincidenDesconoceProcedimientoSolicitaApoyo",
          etiqueta: "Los miembros de mesa desconocían el procedimiento y solicitaron apoyo del personal de la ONPE/ JNE.",
        },
        { campo: "t2CedulasNoCoincidenOtraAccion", etiqueta: "Otro acción" },
      ];
    },
    opcionesIncidenteEscrutinio() {
      return [
        { campo: "t2IncidenteEscrutinioPersonerosNoFacultados", etiqueta: "Personeros no facultados en la mesa" },
        { campo: "t2IncidenteEscrutinioAgresionActores", etiqueta: "Agresión verbal y/o física entre actores electorales" },
        { campo: "t2IncidenteEscrutinioEscrutinioNoPublico", etiqueta: "Impedimento de que el escrutinio sea público (a puerta cerrada)" },
        { campo: "t2IncidenteEscrutinioOtro", etiqueta: "Otro" },
      ];
    },
    opcionesMotivoLaborEscrutinio() {
      return [
        { campo: "t2LaborEscrutinioDesconocimientoLabor", etiqueta: "Desconocimiento de la labor del observador" },
        { campo: "t2LaborEscrutinioRestriccionMovilizarse", etiqueta: "Restricción para movilizarse dentro del local de votación" },
        { campo: "t2LaborEscrutinioRestriccionObservarMesa", etiqueta: "Restricción para observar la mesa de votación" },
        { campo: "t2LaborEscrutinioFaltaRespetoAgresion", etiqueta: "Falta de respeto, agresión contra el observador" },
        { campo: "t2LaborEscrutinioSeparacionInconducta", etiqueta: "Separación del observador por inconducta o faltas a la normativa electoral" },
        { campo: "t2LaborEscrutinioOtro", etiqueta: "Otro" },
      ];
    },
    opcionesActorLaborEscrutinio() {
      return [
        { campo: "t2LaborEscrutinioActorJne", etiqueta: "JNE" },
        { campo: "t2LaborEscrutinioActorOnpe", etiqueta: "ONPE" },
        { campo: "t2LaborEscrutinioActorFfaaPnp", etiqueta: "FFAA/PNP" },
      ];
    },
    partidosActa() {
      return PARTIDOS_ACTA;
    },
    votosPartidosCompletos() {
      return PARTIDOS_ACTA.every((partido) => this.votoPartidoCompleto(this.actual[partido.campo]));
    },
    partidosActaPendientes() {
      return PARTIDOS_ACTA.filter((partido) => !this.votoPartidoCompleto(this.actual[partido.campo])).length;
    },
    isDirty() {
      return JSON.stringify(this.actual) !== JSON.stringify(this.guardado);
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos || this.soloLectura) return;
        this.programarAutoGuardado();
      },
    },
  },
  mounted() {
    this.cargar();
  },
  beforeDestroy() {
    if (this.temporizador) clearTimeout(this.temporizador);
  },
  methods: {
    asignar(evento) {
      this.$set(this.actual, evento.campo, evento.valor);
      if (evento.valor !== true) this.limpiarDependientes(evento.campo);
    },
    limpiarDependientes(campo) {
      const hijos = DEPENDIENTES[campo];
      if (!hijos) return;
      this.limpiarCampos(hijos);
    },
    limpiarCampos(campos) {
      campos.forEach((campo) => {
        if (this.actual[campo] !== null && this.actual[campo] !== undefined) {
          this.$set(this.actual, campo, null);
        }
        this.limpiarDependientes(campo);
      });
    },
    hayDatosEn(campos) {
      return campos.some((campo) => {
        const v = this.actual[campo];
        return v !== null && v !== undefined && v !== "";
      });
    },
    confirmarLimpieza(campos, mensaje, revertir) {
      if (!this.hayDatosEn(campos)) {
        this.limpiarCampos(campos);
        return;
      }
      this.$bvModal
        .msgBoxConfirm(mensaje, {
          title: "Confirmar cambio",
          okTitle: "Sí, borrar y continuar",
          cancelTitle: "Cancelar",
          okVariant: "danger",
          centered: true,
        })
        .then((confirmado) => {
          if (confirmado) this.limpiarCampos(campos);
          else if (typeof revertir === "function") revertir();
        });
    },
    cambiarPermisoIngreso(valor) {
      if (valor !== false) return;
      this.confirmarLimpieza(
        CAMPOS_POSTERIORES_A_INGRESO,
        "Se borrarán las respuestas posteriores a esta pregunta. ¿Deseas continuar?",
        () => this.$set(this.actual, "t2PermitioIngresoLocal", true)
      );
    },
    registrarAsistencia() {
      if (this.soloLectura || this.actual.t2HoraIngreso) return;
      const ahora = new Date();
      const hh = String(ahora.getHours()).padStart(2, "0");
      const mm = String(ahora.getMinutes()).padStart(2, "0");
      this.$set(this.actual, "t2HoraIngreso", hh + ":" + mm);
    },
    urlLogoPartido(logo) {
      return URL_LOGO_OP + logo;
    },
    ocultarLogoRoto(evento) {
      if (evento && evento.target) evento.target.style.visibility = "hidden";
    },
    votoPartidoCompleto(valor) {
      if (valor === null || valor === undefined || valor === "") return false;
      const n = Number(valor);
      return Number.isInteger(n) && n >= 0;
    },
    asignarVotoPartido(campo, bruto) {
      if (bruto === "" || bruto === null) {
        this.$set(this.actual, campo, null);
        return;
      }
      const n = Number(bruto);
      this.$set(this.actual, campo, Number.isInteger(n) && n >= 0 ? n : null);
    },
    textoOrganizaciones(ids) {
      const seleccionadas = String(ids || "")
        .split(SEPARADOR_ORGANIZACIONES)
        .map((x) => x.trim())
        .filter((x) => x.length > 0);
      if (!seleccionadas.length) return null;
      return seleccionadas
        .map((id) => {
          const org = this.organizaciones.find((o) => String(o.parametroId) === id);
          return org ? org.descripcion : id;
        })
        .join(SEPARADOR_ORGANIZACIONES);
    },
    programarAutoGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (this.temporizador) clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.guardar(true), this.intervaloAutoGuardado);
    },
    identificacion() {
      return {
        localVotacionMesaProcesoElectoralId: this.asignacionId || this.localVotacionMesaProcesoElectoralId,
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };
    },
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      const vActual = JSON.stringify(fichaActual[propiedad]);
      const vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      const vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return vActual === vGuardado && vGuardado !== vActualizado
        ? fichaActualizada[propiedad]
        : fichaActual[propiedad];
    },
    aHoraCorta(valor) {
      const texto = String(valor || "").trim();
      return texto.length >= 5 ? texto.substring(0, 5) : null;
    },
    normalizarFichaServidor(ficha) {
      const normalizada = this.cloneObject(ficha || {});
      ["t2HoraIngreso", "t2HoraSalida", "t2HoraInicioEscrutinio"].forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(normalizada, campo)) {
          normalizada[campo] = this.aHoraCorta(normalizada[campo]);
        }
      });
      return normalizada;
    },
    aplicarMeta(d) {
      this.auth = d.auth || {};
      this.porcentajeAvance = d.porcentajeAvanceTurnoActual || 0;
      this.finalizado = d.tieneRegistroFinalizadoTurnoActual === true;
      this.camposPendientes = d.camposPendientes || [];
      this.numeroMesaEsperado = d.numeroMesaEsperado || "";
      if (d.localVotacionMesaProcesoElectoralId) {
        this.asignacionId = d.localVotacionMesaProcesoElectoralId;
        this.$emit("guardado", d);
      }
    },
    onActaGuardada(datos) {
      if (datos) this.aplicarMeta(datos);
      this.$set(this.guardado, "rutaActaEscrutinio", this.actual.rutaActaEscrutinio);
    },
    aplicarFicha(fichaServidor) {
      const ficha = this.normalizarFichaServidor(fichaServidor);

      if (!this.ui.tieneCargaInicial) {
        Object.keys(this.actual).forEach((campo) => {
          if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
            this.actual[campo] = ficha[campo];
          }
        });
        this.guardado = this.cloneObject(this.actual);
        return;
      }

      const tempActual = this.cloneObject(this.actual);
      const tempGuardado = this.cloneObject(this.guardado);
      Object.keys(tempActual).forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
          tempActual[campo] = this.actualizarBaseDiferente(campo, tempActual, tempGuardado, ficha);
        }
      });
      this.actual = this.cloneObject(tempActual);

      const nuevoGuardado = this.cloneObject(this.guardado);
      Object.keys(this.actual).forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
          nuevoGuardado[campo] = ficha[campo];
        }
      });
      this.guardado = nuevoGuardado;
    },
    async cargar() {
      this.ui.estaCargandoDatos = true;
      await this.$http
        .post(this.apiRoute("Ficha2026ErmLima", "GetTurnoDos"), this.identificacion())
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          const d = response.body.data || {};
          this.aplicarMeta(d);
          this.aplicarFicha(d.ficha);
        }, this.mostrarMensajeExcepcionVueResource);
      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
      if (this.isDirty && !this.soloLectura) this.programarAutoGuardado();
    },
    armarRequest() {
      const modelo = this.cloneObject(this.actual);
      Object.assign(modelo, this.identificacion());
      modelo.t2PresenciaPersonerosVotacionOrganizacionesTexto = this.textoOrganizaciones(
        this.actual.t2PresenciaPersonerosVotacionOrganizacionParamIds
      );
      delete modelo.rutaActaEscrutinio;
      return modelo;
    },
    async guardar(silencioso) {
      if (this.ui.estaGuardando || this.soloLectura || this.ui.estaCargandoDatos) return false;
      if (!this.cuestionarioHabilitado) {
        if (!silencioso) {
          this.$bvToast.toast(
            "Completa el nombre del observador, el DNI, el número de mesa y la hora de ingreso antes de guardar.",
            { title: "Turno 2", autoHideDelay: 5000, variant: "warning", solid: true }
          );
        }
        return false;
      }
      if (silencioso && !this.isDirty) return false;

      const actualClone = this.cloneObject(this.actual);
      const modelo = this.armarRequest();

      this.ui.estaGuardando = true;
      let exitoso = false;
      await this.$http
        .post(this.apiRoute("Ficha2026ErmLima", "EditTurnoDos"), modelo)
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.guardado = actualClone;
          exitoso = true;
          this.$emit("guardado", response.body.data);
          if (!silencioso) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 2",
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
          }
        }, this.mostrarMensajeExcepcionVueResource);
      this.ui.estaGuardando = false;

      if (exitoso) await this.cargar();
      return exitoso;
    },
    finalizar() {
      this.$bvModal
        .msgBoxConfirm("¿Confirma que desea finalizar el Turno 2? Después no podrá editarlo.", {
          title: "Finalizar turno",
          okTitle: "Finalizar",
          cancelTitle: "Cancelar",
        })
        .then(async (confirmado) => {
          if (!confirmado) return;
          if (this.isDirty) {
            const guardado = await this.guardar(true);
            if (!guardado) return;
          }
          this.$http
            .post(this.apiRoute("Ficha2026ErmLima", "FinalizarTurno"),
              Object.assign({ turno: 2 }, this.identificacion()))
            .then(function (response) {
              if (this.procesarRespuestaErrorDefecto(response)) {
                const d = response.body.data || {};
                if (d.camposPendientes) this.camposPendientes = d.camposPendientes;
                return;
              }
              this.finalizado = true;
              this.$emit("finalizado", response.body.data);
              this.$bvToast.toast(response.body.message || "Turno finalizado.", {
                title: "Turno 2",
                autoHideDelay: 5000,
                variant: "success",
                solid: true,
              });
            }, this.mostrarMensajeExcepcionVueResource);
        });
    },

    reabrir() {
      this.$bvModal
        .msgBoxConfirm("¿Confirma que desea reabrir el Turno 2? Volverá a ser editable.", {
          title: "Reabrir turno",
          okTitle: "Reabrir",
          cancelTitle: "Cancelar",
        })
        .then((confirmado) => {
          if (!confirmado) return;
          this.ui.estaGuardando = true;
          this.$http
            .post(this.apiRoute("Ficha2026ErmLima", "RevertirTurno"),
              Object.assign({ turno: 2 }, this.identificacion()))
            .then(function (response) {
              this.ui.estaGuardando = false;
              if (this.procesarRespuestaErrorDefecto(response)) return;
              this.aplicarMeta(response.body.data || {});
              this.$emit("finalizado", response.body.data);
              this.$bvToast.toast(response.body.message || "Turno reabierto.", {
                title: "Turno 2",
                autoHideDelay: 5000,
                variant: "success",
                solid: true,
              });
            }, function (error) {
              this.ui.estaGuardando = false;
              this.mostrarMensajeExcepcionVueResource(error);
            });
        });
    },
  },
};
</script>

<style>
.ficha-acta-partidos table {
  background: #fff;
}

.ficha-acta-partidos td,
.ficha-acta-partidos th {
  vertical-align: middle;
  padding: 0.3rem 0.5rem;
}

.ficha-acta-partidos__org {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ficha-acta-partidos__logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
  background: #fff;
  border: 1px solid #e4e6ef;
  border-radius: 3px;
  flex-shrink: 0;
}

.ficha-acta-partidos__col-votos {
  width: 88px;
}

.ficha-acta-partidos__col-votos input {
  min-width: 64px;
}

.ficha-acta-partidos__fila--pendiente td {
  background-color: #fff8f8;
}
</style>

